/**
 * Isolated-VQA control for freeze visuals only. FreezeSentinel detection,
 * server persistence, domain logs, and attribute-at remain active.
 *
 * UI listeners deliberately ignore this event unless `window.playwrightTest`
 * is true, so normal/debug gameplay cannot accidentally mute its warnings.
 */
export const FREEZE_VISUAL_CONTROL_EVENT = 'helix:freeze-visual-control';

export interface FreezeVisualControlDetail {
  hidden: boolean;
  clear?: boolean;
  /** Render one isolated card without subscribing the overlay to live events. */
  preview?: import('./FreezeEventTypes').FreezeEventWire;
}
